import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

const ModalWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    background: rgba(38, 38, 38, 0.8); // must be a semi-transparent color
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalPortal = ({ children }) => {
    const ModalRoot = document.getElementById("modal-root");
    const elRef = useRef(null);
    if (!elRef.current) {
        elRef.current = document.createElement("div");
    }

    useEffect(() => {
        ModalRoot.appendChild(elRef.current);
        return () => {
            ModalRoot.removeChild(elRef.current);
        };
        // eslint-disable-next-line
    }, []);

    return createPortal(<ModalWrapper>{children}</ModalWrapper>, elRef.current);
};

export default ModalPortal;

ModalPortal.propTypes = {
    children: PropTypes.element.isRequired
};
